export const ROUTE_INVITE_SIGNUP = '/invite/signup';
export const ROUTE_INVITE_PASSWORDRESET = '/invite/passwordreset';
export const ROUTE_INVITE_SIGNUP_PENDING = '/invite/signup/pending';
export const ROUTE_REVOKE_SIGNUP = '/invite/signup/pending';
export const ROUTE_SIGNUP = '/signup';
export const ROUTE_LOGIN = '/login';
export const ROUTE_CONDUENT_LOGIN = '/login/conduent';
export const ROUTE_CONDUENT_SIGNUP = '/signup/conduent';
export const ROUTE_PASSWORD_RESET = '/passwordreset';
export const ROUTE_PASSWORD_UPDATE = '/passwordupdate';
export const ROUTE_PASSWORD_UPDATE_COMPONENT = '/passwordupdate';
export const ROUTE_LOGOUT = '/logout';
export const ROUTE_OAUTH = '/oauth';
export const ROUTE_GOOGLE_AUTH = '/googleAuth';
export const ROUTE_MY_PROFILE = '/';
export const ROUTE_EDIT_PROFILE = '/edit-profile';
export const ROUTE_ORG = '/organization';
export const ROUTE_TEAMS = '/organization/:orgId/teams';
export const ROUTE_TEAM = '/organization/:orgId/teams/:id';
export const ROUTE_MEMBERS = '/organization/:orgId/members';
export const ROUTE_MEMBER = '/organization/:orgId/members/:id';
export const ROUTE_COLLABORATORS = '/organization/:orgId/collaborators';
export const ROUTE_COLLABORATOR = '/organization/:orgId/collaborators/:id';
export const ROUTE_ORG_SETTINGS = '/organization/:orgId/settings';
export const ROUTE_BOTS = '/organization/:orgId/bots';
export const ROUTE_BOT = '/organization/:orgId/bots/:id';
export const ROUTE_EDIT_BOT_PROFILE = '/edit-bot-profile/:id';
export const ROUTE_UNAUTHORIZED = '/unauthorized';
export const ROUTE_ADMIN = '/admin';
export const ROUTE_FORGOT = '/forgot';
export const ROUTE_RESET = '/passwordreset';
export const ROUTE_GENERATE_KEYS = '/generatekeys';
export const ROUTE_EDIT_PROFILE_SIGNUP = '/editprofilesignup';
export const ROUTE_CHECK_INVITE = '/checkinvite';
export const ROUTE_GDPR_POLICY_PAGE = '/gdpr-privacy-policy';
export const ROUTE_HOME = '/';
